import { ApiClient } from "@/services/ApiService";

export default {
  async deleteQuestion(id) {
    const response = await ApiClient.delete(`question/${id}`);
    return response.data;
  },
  async getQuestions() {
    const response = await ApiClient.get(`question`);
    return response.data;
  },
  async getQuestion(id) {
    const response = await ApiClient.get(`question/${id}`);
    return response.data;
  },
  async getQuestionsByTestId(id) {
    const response = await ApiClient.get(`question/test/${id}`);
    return response.data;
  },
  async postQuestion(question) {
    const response = await ApiClient.post(`question`, question);
    return response.data;
  },
  async putQuestion(question) {
    const response = await ApiClient.put(
      `question/${question.questionId}`,
      question
    );
    return response.data;
  }
};
